<script setup>
import { ref, computed, onMounted } from 'vue';
import { useLoadWithRetry } from 'dashboard/composables/loadWithRetry';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const { filteredCurrentChatAttachments, attachments, contentAttributes } =
  useMessageContext();

const isSticker = computed(
  () =>
    !!(contentAttributes?.value?.isSticker || contentAttributes?.value?.is_sticker)
);

const attachment = computed(() => attachments.value[0]);

const { isLoaded, hasError, loadWithRetry } = useLoadWithRetry();

const showGallery = ref(false);

onMounted(() => {
  if (attachment.value?.dataUrl) {
    loadWithRetry(attachment.value.dataUrl);
  }
});

const handleImageError = () => {
  hasError.value = true;
};
</script>

<template>
  <BaseBubble
    class="overflow-hidden p-3"
    data-bubble-name="image"
    @click="showGallery = true"
  >
    <div v-if="hasError" class="flex items-center gap-1 text-center rounded-lg">
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      <p class="mb-0 text-n-slate-11">
        {{ $t('COMPONENTS.MEDIA.IMAGE_UNAVAILABLE') }}
      </p>
    </div>
    <div
      v-else-if="isLoaded"
      class="relative group rounded-lg overflow-hidden cursor-pointer"
    >
      <img
        class="skip-context-menu transition-transform duration-200 ease-out"
        :class="isSticker ? 'sz-sticker-img' : 'group-hover:scale-105'"
        :src="attachment.dataUrl"
        :width="attachment.width"
        :height="attachment.height"
      />
      <!-- SZ_IMAGE_HOVER_20260528: no hover, leve zoom na imagem + overlay
           escuro suave + ícone de expandir centralizado. Clique em qualquer
           ponto abre o visualizador. -->
      <div
        v-if="!isSticker"
        class="absolute inset-0 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        style="background-color: rgba(0, 0, 0, 0.35)"
      >
        <Icon icon="i-lucide-scan" class="text-white size-7 drop-shadow-md" />
      </div>
    </div>
  </BaseBubble>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleImageError"
    @close="() => (showGallery = false)"
  />
</template>

<style>
.sz-sticker-img {
  max-width: 200px !important;
  max-height: 200px !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain;
}
</style>
